export const TransactionsList = [
  {
    url: '/transactions/transaction-history',

    name: 'Transaction History',
  },
  {
    url: '/transactions/cash-transfer',
    name: 'Cash Transfer',
  },
  // {
  //   url: '/transactions/Share',
  //   name: 'Share',
  // },
];
